import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { RightSidebarContent } from './RightSidebarContent'
import './RightSidebar.scss'

interface RightSidebarProps {
  isOpen: boolean
  onToggle: () => void
  activeTabPath?: string
  activeLifeSpace: 'personal' | 'work' | 'home' | 'all'
}

const RightSidebarComponent: React.FC<RightSidebarProps> = ({
  isOpen,
  onToggle,
  activeTabPath,
  activeLifeSpace
}) => {
  const { t } = useTranslation()

  // Auto-close on small screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 900 && isOpen) {
        onToggle()
      }
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isOpen, onToggle])

  // Memoize CSS class
  const sidebarClassName = useMemo(
    () => `right-sidebar ${isOpen ? 'right-sidebar--open' : ''}`,
    [isOpen]
  )

  // On the Ziele page the sidebar is a help panel, so the header changes.
  const isGoalsPage = /\/home\/(personal|work|home)\/goals$/.test(activeTabPath ?? '')
  const headerTitle = isGoalsPage ? t('goals.help.title') : t('rightSidebar.title')

  return (
    <div className={sidebarClassName}>
      <div className="right-sidebar__header">
        <h3 className="right-sidebar__title">{headerTitle}</h3>
      </div>

      <div className="right-sidebar__content">
        <RightSidebarContent
          activeTabPath={activeTabPath}
          activeLifeSpace={activeLifeSpace}
        />
      </div>
    </div>
  )
}

// Memoize RightSidebar to prevent unnecessary re-renders
// Only re-renders when props change
export const RightSidebar = React.memo(RightSidebarComponent)
